import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './assets/styles/main.scss';
import { StoreProvider } from '@pascal/pascal-core';
import { init } from './core/init';

const worker = new Worker(`${process.env.PUBLIC_URL}/events.worker.js`);
init();

const App = lazy(() => import('./App'));
const container = document.getElementById('root');

const root = createRoot(container);

root.render(
    <StoreProvider>
      <Suspense fallback={<div></div>}>
        <App/>
      </Suspense>
    </StoreProvider>
);

export { worker };
